// Europe/London wall-clock helpers for the datetime-local schedule input ("YYYY-MM-DDTHH:mm").
const TZ = "Europe/London";
const pad = (n) => String(n).padStart(2, "0");

const londonParts = (date) => {
  const parts = new Intl.DateTimeFormat("en-GB", {
    timeZone: TZ, year: "numeric", month: "2-digit", day: "2-digit",
    hour: "2-digit", minute: "2-digit", hourCycle: "h23",
  }).formatToParts(date);
  const get = (t) => Number(parts.find((p) => p.type === t).value);
  return { y: get("year"), m: get("month"), d: get("day"), h: get("hour"), mi: get("minute") };
};

export const formatLondonLocal = (date) => {
  const p = londonParts(date);
  return `${p.y}-${pad(p.m)}-${pad(p.d)}T${pad(p.h)}:${pad(p.mi)}`;
};

// London wall-clock string -> absolute Date (handles GMT/BST). Returns null if unparseable.
export const londonLocalToDate = (value) => {
  const m = /^(\d{4})-(\d{2})-(\d{2})T(\d{2}):(\d{2})/.exec(value || "");
  if (!m) return null;
  const [y, mo, d, h, mi] = m.slice(1).map(Number);
  const wall = Date.UTC(y, mo - 1, d, h, mi);
  let ts = wall;
  for (let i = 0; i < 2; i++) {
    const p = londonParts(new Date(ts));
    ts = wall - (Date.UTC(p.y, p.m - 1, p.d, p.h, p.mi) - ts);
  }
  return new Date(ts);
};

// ~30 min ahead, rounded up to the next 5 minutes, in London time.
export const defaultScheduleValue = (now = Date.now()) => {
  const step = 5 * 60 * 1000;
  return formatLondonLocal(new Date(Math.ceil((now + 30 * 60 * 1000) / step) * step));
};

export const SCHEDULE_MIN_LEAD_MS = 15 * 60 * 1000;
export const SCHEDULE_MAX_AHEAD_MS = 30 * 24 * 60 * 60 * 1000;

// Returns a user-facing reason the scheduled time is unusable, or null when valid.
export const scheduleProblem = (value, now = Date.now()) => {
  if (!value) return "Choose a pickup date & time";
  const dt = londonLocalToDate(value);
  if (!dt || isNaN(dt.getTime())) return "Enter a valid pickup date & time";
  if (dt.getTime() - now < SCHEDULE_MIN_LEAD_MS) return "Pickup must be at least 15 minutes from now";
  if (dt.getTime() - now > SCHEDULE_MAX_AHEAD_MS) return "Pickups can be booked up to 30 days ahead";
  return null;
};
